import React from "react";

function SettingsEnormail() {
    return (
        <React.Fragment>
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">Enormail</h5>
                    <p className="card-text">
                        Binnenkort kan hier Enormail zelf worden ingesteld. Als je nu al Enormail wilt gebruiken, neem dan contact op met ShopCrate.
                    </p>
                </div>
            </div>
        </React.Fragment>
    );
}

export default React.memo(SettingsEnormail);
